import { useState } from "react";
import { BiHide, BiShow } from "react-icons/bi";
import MeritoButton from "../MeritoButtons/MeritoButtons";
import styles from "./MeritoPasswordField.module.scss";

interface MeritoPasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  onEnter?: () => void;
}

const MeritoPasswordField = ({
  value,
  onChange,
  placeholder = "Enter password",
  error = false,
  disabled = false,
  autoComplete = "new-password",
  onEnter,
}: MeritoPasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div
      className={`${styles.field} ${error ? styles.error : ""} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <input
        type={showPassword ? "text" : "password"}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        aria-invalid={error || undefined}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== "Enter" || !onEnter) return;
          event.preventDefault();
          onEnter();
        }}
      />
      <MeritoButton
        type="tertiary"
        size="md2"
        onlyIcon
        hover={false}
        disabled={disabled}
        ariaLabel={showPassword ? "Hide password" : "Show password"}
        className={styles.visibilityButton}
        icon={showPassword ? <BiHide /> : <BiShow />}
        onClick={() => setShowPassword((current) => !current)}
      />
    </div>
  );
};

export default MeritoPasswordField;
